<template>
    <div class="aboutUs-container">
        <header-nav></header-nav>

        <div class="main">
            <section ref="section-1" class="section headeImg">
                <div class="contentBox">
                    <p class="h1p">智慧养老康养整体解决方案</p>
                    <p class="h5p" style="max-width: none;height: 45px;">新巢天诚依托科技与温情，打造安全、便捷、有尊严的晚年生活。</p>
                    <p class="h5p" style="max-width: none;height: 45px;margin-top: 0px;">通过智能设备与专业服务，实现健康监测、应急响应、精神关怀一体化，让长者舒心，子女安心。</p>
                </div>
            </section>

            <section ref="section-2" class="section businessPainPoint">
                <div class="contentBox">
                    <div class="solutionName">业务痛点</div>
                    <div class="list">
                        <div class="item">
                            <div class="titieWarp">
                                <img class="icon" src="../../assets/images/solutionPages/seniorLiving/listItem1.png" alt="">
                                <p>技术适配与产品设计</p>
                            </div>
                            <div class="contont">
                                智能产品操作复杂，与老年人使用习惯不匹配；功能冗余且价格高昂，超出普通家庭承受能力；养老服务、医疗康养等产业链条未能充分整合。
                            </div>
                        </div>
                        <div class="item">
                            <div class="titieWarp">
                                <img class="icon" src="../../assets/images/solutionPages/seniorLiving/listItem2.png" alt="">
                                <p>支付能力与市场机制</p>
                            </div>
                            <div class="contont">
                                支付端过度依赖个人储蓄，支付能力不足；尚未形成完善的市场化机制。
                            </div>
                        </div>
                        <div class="item">
                            <div class="titieWarp">
                                <img class="icon" src="../../assets/images/solutionPages/seniorLiving/listItem3.png" alt="">
                                <p>数据安全与隐私保护</p>
                            </div>
                            <div class="contont">
                                存在老年人隐私信息（如健康数据、位置信息）泄露和被滥用的风险；数据统筹层次不高，阻滞了信息共享。
                            </div>
                        </div>
                        <div class="item">
                            <div class="titieWarp">
                                <img class="icon" src="../../assets/images/solutionPages/seniorLiving/listItem4.png" alt="">
                                <p>基础设施与资源均衡</p>
                            </div>
                            <div class="contont">
                                城乡及区域间基础设施发展不平衡；农村及偏远地区网络覆盖率低，老旧社区智能化改造难度大。
                            </div>
                        </div>
                        <div class="item">
                            <div class="titieWarp">
                                <img class="icon" src="../../assets/images/solutionPages/seniorLiving/listItem5.png" alt="">
                                <p>专业人才短缺</p>
                            </div>
                            <div class="contont">
                                既懂养老服务又掌握智能技术的复合型人才稀缺；养老机构护理人员工作压力大，且缺乏专业培训。
                            </div>
                        </div>
                        <div class="item">
                            <div class="titieWarp">
                                <img class="icon" src="../../assets/images/solutionPages/seniorLiving/listItem6.png" alt="">
                                <p>老人与家属的信任壁垒</p>
                            </div>
                            <div class="contont">
                                部分老人对智能设备存在 “技术恐惧”，担心操作复杂、被诈骗；家属对数据准确性、服务可靠性存疑，不愿将老人的安全完全托付给智慧方案。
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section ref="section-3" class="section shequ">
                <div class="contentBox">
                    <div class="solutionName">社区居家智慧养老整体解决方案</div>
                    <div class="imgWarp14">
                        <div class="leftContent">
                            <img class="infoImg l1" src="../../assets/images/solutionPages/seniorLiving/shequ1.png" alt="">
                        </div>
                        <div class="rightContent">
                            <img class="infoImg r1" src="../../assets/images/solutionPages/seniorLiving/shequ2.png" alt="">
                            <img class="infoImg r2" src="../../assets/images/solutionPages/seniorLiving/shequ3.png" alt="">
                            <img class="infoImg r3" src="../../assets/images/solutionPages/seniorLiving/shequ4.png" alt="">
                            <img class="infoImg r4" src="../../assets/images/solutionPages/seniorLiving/shequ5.png" alt="">
                        </div>
                    </div>
                </div>
            </section>

            <section ref="section-4" class="section jigou">
                <div class="contentBox">
                    <div class="solutionName">养老机构智慧整体解决方案</div>
                    <div class="imgWarp14">
                        <div class="leftContent">
                            <img class="infoImg l1" src="../../assets/images/solutionPages/seniorLiving/jigou1.png" alt="">
                        </div>
                        <div class="rightContent">
                            <img class="infoImg r1" src="../../assets/images/solutionPages/seniorLiving/jigou2.png" alt="">
                            <img class="infoImg r2" src="../../assets/images/solutionPages/seniorLiving/jigou3.png" alt="">
                            <img class="infoImg r3" src="../../assets/images/solutionPages/seniorLiving/jigou4.png" alt="">
                            <img class="infoImg r4" src="../../assets/images/solutionPages/seniorLiving/jigou5.png" alt="">
                        </div>
                    </div>
                </div>
            </section>

            <section ref="section-5" class="section fuwuzhongxin">
                <div class="contentBox">
                    <div class="solutionName">社区养老服务中心建设解决方案</div>
                    <div class="imgWarp21">
                        <div class="leftContent">
                            <img class="infoImg l1" src="../../assets/images/solutionPages/seniorLiving/fuwuzhongxin1.png" alt="">
                            <img class="infoImg l2" src="../../assets/images/solutionPages/seniorLiving/fuwuzhongxin2.png" alt="">
                        </div>
                        <div class="rightContent">
                            <img class="infoImg r1" src="../../assets/images/solutionPages/seniorLiving/fuwuzhongxin3.png" alt="">
                        </div>
                    </div>
                </div>
            </section>

            <section ref="section-6" class="section pingtai">
                <div class="contentBox">
                    <div class="solutionName">智慧康养信息化平台</div>
                    <div class="imgWarp32">
                        <div class="topContent">
                            <img class="infoImg t1" src="../../assets/images/solutionPages/seniorLiving/pingtai1.png" alt="">
                            <img class="infoImg t2" src="../../assets/images/solutionPages/seniorLiving/pingtai2.png" alt="">
                            <img class="infoImg t3" src="../../assets/images/solutionPages/seniorLiving/pingtai3.png" alt="">
                        </div>
                        <div class="bottomContent">
                            <img class="infoImg b1" src="../../assets/images/solutionPages/seniorLiving/pingtai4.png" alt="">
                            <img class="infoImg b2" src="../../assets/images/solutionPages/seniorLiving/pingtai5.png" alt="">
                        </div>
                    </div>
                </div>
            </section>

        </div>

        <footer-nav></footer-nav>
        <!-- 定位栏 -->
        <location-column></location-column>
    </div>
</template>
  
<script>
  import headerNav from "@/components/header-nav";
  import footerNav from "@/components/footer-nav";
  export default {
    name: "cooperation",
    components: { headerNav, footerNav },
    metaInfo: {
      meta: [
        {
          name: "keywords",
          content:
            "新巢天诚NB-IoT智能门锁，CAT.1物联网锁，Wi-Fi智能锁，4G智能门锁，校园智能门锁，保障性住房管理平台，公租房管理系统，人才公寓管理系统，网约房（出租屋管理系统），智慧校园后勤管理系统，智慧园区企业后勤管理系统。",
        },
        {
          name: "description",
          content:
            "江苏新巢天诚智能技术有限公司（简称：天诚）专注于物联网多形态智能硬件的产品研发与制造，为不同垂直领域的客户提供整体解决方案服务，深度赋能公租房.人才公寓、智慧公寓、人才公寓、保障性住房、智慧校园、企业园区宿舍、智慧后勤，网约房（出租屋）等行业应用场景。天诚自主研发的多模态计算机视觉与生物识别物联网锁，采用NB-IoT、CAT.1、Wi-Fi、4G,5G等无线通讯技术。打造整体的智能硬件解决方案。",
        },
      ],
    },
    data() {
        return {
            copyDom: "",
            lastScrollTop: 0,
            scrollDirection: 'down',
            isScrolling: false,
            scrollStopTimer: null,
            scrollThrottle: null,
        };
    },
    methods: {
        getAnimationClass(section) {
            return Array.from(section.classList).find(item => item.startsWith('animationClass-'));
        },

        handleScroll() {
            this.isScrolling = true;
            clearTimeout(this.scrollStopTimer)
            this.scrollStopTimer = setTimeout(() => {
                this.isScrolling = false
            }, 150)

            if (!this.scrollThrottle) {
                this.scrollThrottle = requestAnimationFrame(() => {
                // 获取窗口滚动位置（兼容不同浏览器）
                const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;

                // 保持原有方向判断逻辑
                if (Math.abs(currentScrollTop - this.lastScrollTop) > 10) {
                    this.scrollDirection = currentScrollTop > this.lastScrollTop ? 'down' : 'up';
                }
                    this.lastScrollTop = currentScrollTop;
                    this.scrollThrottle = null;
                })
            }
        },

        // 动画触发方法
        triggerAnimation(section) {
            section.classList.remove('active');   // 移除动画类以确保可以重新触发
            void section.offsetWidth; // 强制重绘，确保动画重置
            section.classList.add('active'); // 重新添加动画类以触发淡入


            // //类名不固定时使用
            // const animationClass = this.getAnimationClass(section); //获取class类名
            // section.classList.remove(`${animationClass}-active`);   // 移除动画类以确保可以重新触发
            // void section.offsetWidth; // 强制重绘，确保动画重置
            // section.classList.add(`${animationClass}-active`); // 重新添加动画类以触发淡入
            
            // // 动画结束后自动移除类
            // section.addEventListener('animationend', () => {
            //     section.classList.remove(`${animationClass}-active`);
            // }, { once: true });
        },
    },
    created() {

    },
    mounted() {
        document.title = this.$store.state.searchTitle;

        window.addEventListener('scroll', this.handleScroll);
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    if(this.scrollDirection == 'down'){ 
                        if(this.copyDom == entry.target) return;
                        console.log("当前过渡元素",entry.target)

                        const section = entry.target;
                        this.triggerAnimation(section);
                        this.copyDom = entry.target;
                    }else{ 
                        console.log("向上滚动")
                        this.copyDom = '';
                    }
                }
            })
        },{
            threshold: 0,
            // rootMargin: "0px 0px -100px 0px" // 添加底部负边距防止过早触发
        });

        this.$nextTick(() => {
            for(let i = 1; i <= 6; i++) {
                observer.observe(this.$refs[`section-${i}`])
            }
        });
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.handleScroll)
    },
  };
</script>
  
<style scoped lang="less">
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(150px);
  }
  to {
    opacity: 1;
    transform: translateY(0px);
  }
}
.aboutUs-container {
    /* min-width: 1366px; */
    .main {
        width: 100%;
        padding-top: 80px;
        .section{
            border: 1px solid transparent;
            .contentBox{
                width: 1300px;
                margin: 0 auto;
                opacity: 0;
                transition: opacity 0.5s ease-out;
                .solutionName{
                    height: 28px;
                    line-height: 28px;
                    font-size: 31px;
                    color: #000103;
                    position: relative;
                    margin-top: 50px;
                    // padding-bottom: 25px;
                    // margin-bottom: 12px;
                    &::after{
                        position: absolute;
                        content: "";
                        height: 3px;
                        width: 156px;
                        background-color: #1B5CDB;
                        bottom: -30px;
                        left: calc(50% - 78px); 
                    }
                }
                .imgWarp14{
                    display: flex;
                    margin-top: 50px;
                    margin-bottom: 50px;
                    .leftContent{
                        margin-right: 14px;
                        .infoImg{
                            width: 655px;
                            // height: 520px;
                            &.l1{

                            }
                        }
                    }
                    .rightContent{
                        display: flex;
                        flex-wrap: wrap;
                        align-content: center;
                        justify-content: center;
                        // gap:39px 20px;
                        gap:20px;
                        .infoImg{
                            width: 305px;
                            height: 171px;
                            &.r1,&.r2,&.r3,&.r4{

                            }
                        }
                    }
                }
                .imgWarp21{
                    display: flex;
                    margin-top: 50px;
                    margin-bottom: 50px;
                    .leftContent{
                        display: flex;
                        flex-direction: column;
                        gap: 28px;
                        margin-right: 55px;
                        .infoImg{
                            width: 510px;
                            height: 360px;
                            &.l1{

                            }
                        }
                    }
                    .rightContent{
                        display: flex;
                        align-items: center;
                        .infoImg{
                            width: 731px;
                            height: 710px;
                            &.r1,&.r2,&.r3,&.r4{

                            }
                        }
                    }
                }
                .imgWarp32{
                    margin-top: 50px;
                    margin-bottom: 50px;
                    .topContent{
                        display: flex;
                        gap: 29px;
                        margin-bottom: 68px;
                        .infoImg{
                            width: 420px;
                            height: 221px;
                            &.t1,&.t2,&.t3{

                            }
                        }
                    }
                    .bottomContent{
                        display: flex;
                        align-items: center;
                        gap: 50px;
                        .infoImg{
                            width: 547px;
                            height: 262px;
                            &.b1{
                                width: 547px;
                                height: 262px;
                            }
                            &.b2{
                                width: 714px;
                                height: 377px;
                            }
                        }
                    }
                }
            }
            &.active{
                .contentBox{
                    animation: fadeIn 1.5s forwards;
                }
            }
        }
        .headeImg{
            width: 100%;
            height: 749px;
            // height: 562px;
            background-image: url("../../assets/images/solutionPages/seniorLiving/backImg.jpg");
            background-size: cover;
            background-position: center center;
            background-repeat: no-repeat;
            // &.active{
            //     .contentBox{
            //         animation: fadeIn 1s forwards;
            //     }
            // }
            .contentBox{
                height: 100%;
                padding-top:179px;
                .h1p{
                    height: 42px;
                    line-height: 42px;
                    font-size: 46px;
                    color: #F3F6FB;
                    text-align: left;
                    opacity: 0.9;
                }
                .h5p{
                    margin-top: 45px;
                    max-width: 712px;
                    height: 59px;
                    line-height: 45px;
                    font-size: 19px;
                    color: #F9FAFB;
                    text-align: left;
                    opacity: 0.8;
                }
            }
        }
        .businessPainPoint{
            .contentBox{
                width: 1300px;
                // min-height: 785px;
                .list{
                    display: flex;
                    flex-wrap: wrap;
                    justify-content: space-between;
                    margin-top: 70px;
                    margin-bottom:40px;
                    .item{
                        // width: 46%;
                        // height: 177px;
                        width: 630px;
                        min-height: 153px;
                        padding: 17px 31px 0px 31px;
                        box-sizing: border-box;
                        background: #A6CCFCAD;
                        border-radius: 18px 18px 18px 18px;
                        margin-bottom: 40px;
                        .titieWarp{
                            display: flex;
                            align-items: flex-end;
                            .icon{
                                width:42px;
                                height:42px;
                                margin-right: 10px;
                            }
                            p{
                                font-size: 26px;
                                color: #000103;
                            }
                        }
                        .contont{
                            text-align:left;
                            margin-top:10px;
                            margin-left: 46px;
                            font-size: 18px;
                            color: #606060;
                            line-height:26px;
                        }
                    }
                }
            }
        }
        .shequ{
            background-color:#F0F6FF;
        }
        .jigou{
            background-color:#FFF7F1;
        }
        .fuwuzhongxin{
            background-color:#FAFBFC;
        }
        .pingtai{
            background-color:#D2EBFC;
        }
    }
}
//   .header-content {
//     height: 160px;
//     margin: auto;
//     padding-top: 120px;
//     padding-left: 20px;
//   }
//   .title {
//     font-size: 40px;
//     margin-top: 30px;
//     font-weight: bold;
//   }
//   .contact_list {
//     margin-top: 40px;
//     width: 1200px;
//     margin: auto;
//   }
//   .line {
//     width: 80px;
//     margin: auto;
//     border-bottom: 2px solid #d34100;
//     margin-top: 10px;
//   }
//   .content {
//     font-size: 15px;
//     padding-top: 20px;
//     color: #333333;
//     margin: auto;
//     text-align: left;
//     letter-spacing: 2px;
//     line-height: 25px;
//   }

@media screen and (max-width: 768px) {
    .main {
      padding-top: 50px !important;
    }
    .main-header {
      height: 166px !important;
    }
    .solutionName {
      font-size: 20px !important;
      margin-top: 20px !important;
      &::after{
        height: 3px !important;
        width: 83px !important;
        bottom: -10px !important;
        left: calc(50% - 41px) !important; 
      }
    }
    .headeImg{
        height: 166px !important;
        .contentBox{
            padding-top:25px !important;
            .h1p{
                height: 42px !important;
                line-height: 42px !important;
                font-size: 24px !important;
                padding-left: 10px;
            }
            .h5p{
                margin-top: 5px !important;
                max-width: 712px !important;
                height: 59px !important;
                line-height: 22px !important;
                font-size: 14px !important;
                padding-left: 10px;
            }
        }
    }
    .contentBox{
        width: 100% !important;
        .imgWarp14{
            display: flex !important;
            flex-direction: column !important;
            margin-top: 20px !important;
            margin-bottom: 20px !important;
            .leftContent{
                margin-right: 0px !important;
                .infoImg{
                    width: 100% !important;
                    height: auto !important;
                    &.l1{

                    }
                }
            }
            .rightContent{
                display: flex !important;
                flex-wrap: wrap !important;
                align-content: center !important;
                justify-content: center !important;
                // gap:39px 20px;
                gap:10px !important;
                .infoImg{
                    width: 100% !important;
                    height: auto !important;
                    &.r1,&.r2,&.r3,&.r4{

                    }
                }
            }
        }
        .imgWarp21{
            display: flex !important;
            flex-direction: column !important;
            margin-top: 20px !important;
            margin-bottom: 20px !important;
            .leftContent{
                display: flex !important;
                flex-direction: column !important;
                gap: 10px !important;
                margin-right: 0px !important;
                .infoImg{
                    width: 100% !important;
                    height: auto !important;
                    &.l1{

                    }
                }
            }
            .rightContent{
                margin-top: 14px !important;
                display: flex !important;
                align-items: center !important;
                .infoImg{
                    width: 100% !important;
                    height: auto !important;
                    &.r1,&.r2,&.r3,&.r4{

                    }
                }
            }
        }
        .imgWarp32{
            margin-top: 40px !important;
            margin-bottom: 40px !important;
            .topContent{
                display: flex !important;
                flex-direction: column !important;
                gap: 10px !important;
                margin-bottom: 40px !important;
                .infoImg{
                    width: 100% !important;
                    height: auto !important;
                    &.t1,&.t2,&.t3{

                    }
                }
            }
            .bottomContent{
                display: flex !important;
                flex-direction: column !important;
                align-items: center !important;
                gap: 10px !important;
                .infoImg{
                    width: 100% !important;
                    height: auto !important;
                }
            }
        }
    }

    .businessPainPoint{
        .contentBox{
            width: 100% !important;
            .list{
                margin-top: 40px !important;
                margin-bottom:10px !important;
                .item{
                    width: 100% !important;
                    min-height: 123px !important;
                    padding: 10px 16px 0px 20px !important;
                    margin: 0px 30px !important;
                    margin-bottom: 20px !important;
                    .titieWarp{
                        .icon{
                            width:30px !important;
                            height:30px !important;
                            margin-right: 10px !important;
                        }
                        p{
                            font-size: 16px !important;
                        }
                    }
                    .contont{
                        margin-top:6px !important;
                        margin-left: 30px !important;
                        font-size: 14px !important;
                        line-height:20px !important;
                    }
                }
            }
        }
    }
}

@keyframes fadeIn {
    from {
        opacity: 0;
        transform: translateY(150px);
    }
    to {
        opacity: 1;
        transform: translateY(0px);
    }
}
@keyframes fadeOn {
    from {
        opacity: 0;
        transform: translateX(-150px);
    }
    to {
        opacity: 1;
        transform: translateX(0px);
    }
}
</style>